export { Certification, type CertificationProps } from './Certification';